import { cn } from '@/utils/utils.ts';
import { BellIcon } from '@/assets/bell-icon.tsx';
import { Button } from '@/components/ui/button.tsx';
import { useGetNotificationsQuery } from '@/features/notifications/hooks/queries/get-all-notifications.ts';
import { PopoverTrigger } from '@/components/ui/popover.tsx';
import { useNotificationsStore } from '@/services/store/use-notifications-store.ts';

export const NotificationTrigger = () => {
  const notificationFilter = useNotificationsStore((state) => state.notificationFilter);
  const { data } = useGetNotificationsQuery({ notificationFilter });

  const unreadCount = data?.pages?.filter(({ status }) => status === 'unread')?.length;
  const isLastPage = data?.isLastPage;

  const notificationsNumberLabel = isLastPage ? String(unreadCount) : `+${unreadCount}`;

  return (
    <PopoverTrigger asChild>
      <Button
        variant="ghost"
        className="relative h-10 w-10 rounded-full p-0 transition-colors duration-200 hover:bg-white"
      >
        <BellIcon />
        {Boolean(unreadCount) && (
          <div
            className={cn(
              'absolute top-0 right-0 flex items-center justify-center rounded-full bg-[#0ea5e9] px-1 py-0 text-xs text-[10px] text-white',
              notificationsNumberLabel.length === 3
                ? 'right-0 py-0.5'
                : notificationsNumberLabel.length === 2
                  ? 'right-1 py-0.5'
                  : 'right-2'
            )}
          >
            {notificationsNumberLabel}
          </div>
        )}
      </Button>
    </PopoverTrigger>
  );
};
